import React from "react";
import { Check, MessageCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function PainPointQualifier() {
  const painPoints = ["You want maximum results in minimum time", "You’re busy and don’t want to travel. Time is money!", "You’ve tried doing it yourself but haven't seen much results", "You want someone who actually shows up and knows what they're doing."];
  return <section id="is-this-you" className="relative py-24 px-4 flex justify-center items-center min-h-[80vh] overflow-hidden bg-background">
      <div className="absolute inset-0 z-0">
        <img src="https://fun-bengal.10web.cloud/wp-content/uploads/2026/05/Gemini_Generated_Image_wuhtbfwuhtbfwuht-1.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662846/img/retro_outdoor_fitness_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662846/img/retro_outdoor_fitness_bg.png-wvc-sizes" alt="Retro outdoor fitness training background Singapore lifestyle" className="w-full h-full object-cover !opacity-[0.57]" loading="lazy" />
        <div className="absolute inset-0 backdrop-blur-[2px] bg-background/0 !opacity-[0]"></div>
      </div>

      <Card className="relative z-10 w-full max-w-md bg-linear-to-br from-[#F2E4D0] to-[#F9F3E9] border border-[#E8734A]/30 shadow-2xl rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
        <CardContent className="p-8 md:p-10 flex flex-col gap-6">
          <h2 className="text-3xl md:text-4xl text-[#E8734A] font-header text-center uppercase tracking-widest mb-2">
            Is This You?
          </h2>

          <div className="flex flex-col gap-5">
            {painPoints.map((point, i) => <div key={i} data-index={i} className="flex items-start gap-3">
                <Check className="size-5 text-[#E8734A] shrink-0 mt-1" />
                <p className="text-[#1A1008] font-sans italic text-base md:text-lg leading-relaxed font-medium">
                  {point}
                </p>
              </div>)}
          </div>

          <div className="mt-8">
            <Link to="https://wa.me/6588990728" className="w-full rounded-lg bg-[#E8734A] border border-[#E8734A] text-white hover:bg-white hover:text-[#E8734A] transition-all duration-300 hover:-translate-y-1 h-14 text-lg font-semibold shadow-md hover:shadow-lg flex items-center justify-center gap-2">
              Yup, that's me
              <MessageCircle className="w-6 h-6" />
            </Link>
          </div>
        </CardContent>
      </Card>
    </section>;
}